import * as React from 'react';

import {CommunicationsPageContainer} from './containers';

export const CommunicationsPage: React.FC = () => {
    return (
        <CommunicationsPageContainer />
    );
};
